import {GenericMetaNode} from "./GenericMetaNode";
import {PAny} from "../properties/PAny";
import {MaterialNamesList} from "../../ui/inputs/MaterialNamesList";
import {Model3dInfos} from "../../ui/inputs/Model3dInfos";
import * as THREE from "three";
import {json, MetadataRow} from "../../global";

export class Model extends GenericMetaNode {

    ModelData: json;
    object3d: THREE.Object3D;

    // constructor(metatable, meta) {
    //     super(metatable, meta);
    // }

    // fromMetadataRow(row) {
    //     super.fromMetadataRow(row);
    //     const mmrList = this.findProperty('_ModelMaterialRelation') as PNodeList<any>;
    //     const metaData = row.ModelMaterialRelation ?? [];
    //     metaData.forEach(row => {
    //         const node = mmrList.createInstance(this).fromMetadataRow(row);
    //         mmrList.add(node);
    //     });
    //     return this;
    // }

    // updateScene() {
    //     super.updateScene();
    //     this.meta.ModelMaterialRelation.forEach(mmr=>mmr.updateScene());
    // }

    /**
     * Dient der Strukturierung und Ergänzung vorhandener Properties, welche mittels Reflektion ermittelt werden
     */

    toMetadataRow(): MetadataRow {
        const row = super.toMetadataRow();
        row['ModelData'] = {...this.meta['ModelData']};
        return row;
    }


    createProperties(): any {
        const properties = [
            ...super.createProperties(),
            new PAny({
                name: "_3dInfos",
                label: null,
                inputComponent: Model3dInfos,
                metadataPersistent: false,
                node: this
            }),
            new PAny({
                name: "_Materialien",
                label: null,
                inputComponent: MaterialNamesList,
                metadataPersistent: false,
                node: this
            }),
        ];
        return this.orderAndGroup(
            // @ts-ignore
            [
                {group: 'Preview', open: true},
                {name: 'Path'},
                {group: I18N("scene editor:mainparameter"), open: true},
                {name: 'Key'},
                {unused: true},
            ].concat(
                // @ts-ignore
                APP.metadata.ModelMaterialRelation
                    ? [
                        {group: I18N("scene editor:material replacement")},
                        {name: "ModelMaterialRelation"},
                    ]
                    : []
            ).concat([
                {group: I18N("scene editor:found material names")},
                {name: "_Materialien"},
                {group: "3D-Infos"},
                {name: "_3dInfos"},
            ]),
            properties
        );
    }

}
